export const isOffline = () => {
  return localStorage.getItem('appMode') === 'offline'
}
